import React from "react";
import "../../styles/RecentTransactions.css";

const RecentTransactions = ({
    transactions = [],
}) => {

    return (

        <div className="report-card">

            <h3>

                Recent Transactions

            </h3>

            <table className="report-table">

                <thead>

                    <tr>

                        <th>ID</th>

                        <th>Customer</th>

                        <th>Amount</th>

                        <th>Status</th>

                    </tr>

                </thead>

                <tbody>

                    {transactions.length === 0 ? (

                        <tr>

                            <td colSpan="4">

                                No Transactions

                            </td>

                        </tr>

                    ) : (

                        transactions.map((item) => (

                            <tr key={item._id}>

                                <td>

                                    {item.transactionId}

                                </td>

                                <td>

                                    {item.customerName}

                                </td>

                                <td>

                                    ₹{item.amount}

                                </td>

                                <td>

                                    {item.status}

                                </td>

                            </tr>

                        ))

                    )}

                </tbody>

            </table>

        </div>

    );

};

export default RecentTransactions;